<template>
  <div class="time">
    <span :title="standardTime(time)">{{formatTime(time)}}</span>
  </div>
</template>

<script type="text/javascript">
import {formatTime, standardTime} from '@/utils/time'

export default {
  props: ['time'],
  methods: {
    formatTime,
    standardTime
  }
}
</script>

<style type="text/css" scoped>
  .time{
    display: inline-block;
  }
</style>